import { useState } from "react";
import { useParams } from "react-router-dom";
import { Modal, DatePicker, Popconfirm, Button } from "antd";
import {
  ArrowRightOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { startUpdateFecha } from "../../../context/actions/detalleActions";
import { dateFromString } from "../../../utils/dateFromString";
import { useDispatch } from "react-redux";
import { ModalLiberar } from "./modalLiberar/ModalLiberar";
import { startSetEscalamientoAsignacion, startSetTomaEscalamientoAsignacion } from "../../../context/actions/escalamientoAsignacionActions";
import { AsignadoListening } from "./AsignadoListening";

export const Asignado = ({
  asistencia: {
    estatusID,
    fechaAsignacion,
    fechaEscalamientoAsignacion,
    fechaLiberaEscalamientoAsignacion,
    usuarioTomaEscalamientoNombre,
    fechaTomaEscalamiento,
  },
}) => {
  ////////////////////////////
  const dispatch = useDispatch();

  const date = dateFromString(fechaAsignacion);
  const { asistenciaID } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [fecha, setFecha] = useState("");
  const [showLiberar, setShowLiberar] = useState(false);

  const handleModalOK = () => {
    const body = {
      fecha,
      asistenciaID,
      tipo: 7, // Asignacion
    };
    dispatch(startUpdateFecha(body));

    setShowModal(false);
  };

  const onDateChange = (momentTime, stringTime) => setFecha(stringTime);

  const submitEscalar = () =>
    dispatch(startSetEscalamientoAsignacion({ asistenciaID }));

  const submitTomarAsignamiento = () =>
    dispatch(startSetTomaEscalamientoAsignacion({ asistenciaID }));

  if (estatusID > 2)
    return (
      <div onDoubleClick={() => setShowModal(true)}>
        <ClockCircleOutlined /> {date.dateStep}
        <Modal
          title="Cambiar Fecha Asignación"
          open={showModal}
          onOk={handleModalOK}
          onCancel={() => setShowModal(false)}
        >
          <DatePicker showTime onChange={onDateChange} />
        </Modal>
      </div>
    );

  ////////////////////////////

  if (estatusID === 2)
    return (
      <div>
        {!fechaEscalamientoAsignacion ? (
          <Popconfirm
            title="¿Estas seguro de escalar el servicio?"
            onConfirm={submitEscalar}
            onCancel={() => {}}
            okText="Si"
            cancelText="No"
          >
            <div className="marcarStep" style={{ color: "red" }}>
              <ExclamationCircleOutlined /> Escalar !
            </div>
          </Popconfirm>
        ) : (
          <>
            {fechaLiberaEscalamientoAsignacion ? (
              <div className="marcarStep" style={{ color: "green" }}>
                <CheckCircleOutlined /> Liberado !!
                <Popconfirm
                  title="¿Estas seguro de escalar el servicio?"
                  onConfirm={submitEscalar}
                  onCancel={() => {}}
                  okText="Si"
                  cancelText="No"
                >
                  <div className="marcarStep" style={{ color: "red", marginTop: 3 }}>
                    <ExclamationCircleOutlined /> Escalar de nuevo !
                  </div>
                </Popconfirm>
              </div>
            ) : (
              <div
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 6,
                  padding: 10,
                  backgroundColor: "#fafafa",
                  marginTop: 5,
                  textAlign: "center"
                }}
              >
                <div className="marcarStep" style={{ color: "green", marginBottom: 8 }}>
                  <InfoCircleOutlined /> Escalado
                </div>
                {!usuarioTomaEscalamientoNombre ? (
                  <Popconfirm
                    title="¿Estás seguro de tomar este asignamiento?"
                    onConfirm={submitTomarAsignamiento}
                    onCancel={() => {}}
                    okText="Si"
                    cancelText="No"
                  >
                    <Button
                      type="primary"
                      size="small"
                      style={{ fontSize: 11, borderRadius: 6, marginBottom: 8 }}
                    >
                      Tomar Asignación
                    </Button>
                  </Popconfirm>
                ) : (
                  <div style={{ fontSize: 10, marginBottom: 8 }}>
                    <strong>Tomado por:</strong> {usuarioTomaEscalamientoNombre}
                  </div>
                )}
                <Button
                  onClick={() => setShowLiberar(true)}
                  type="link"
                  size="small"
                  block
                >
                  Liberar <ArrowRightOutlined />
                </Button>
                <ModalLiberar open={showLiberar} setOpen={setShowLiberar} />
              </div>
            )}
          </>
        )}
        <AsignadoListening />
      </div>
    );

  return <></>;
};
